import React, { FC } from 'react';
import { Box, Typography, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { UserAvatar } from '../../user-avatar/user-avatar.component';
import { palette } from '../../../theme';

export interface CoachAthleteMemberPreview {
  name: string;
  profileImage?: string | null;
}

export interface CoachAthleteModalHeaderProps {
  memberPreview: CoachAthleteMemberPreview;
  teamName?: string;
  groupName?: string;
  onClose: () => void;
}

const CoachAthleteModalHeader: FC<CoachAthleteModalHeaderProps> = ({ memberPreview, teamName, groupName, onClose }) => {
  const teamGroupSubtitle = [teamName, groupName].filter(Boolean).join(' · ');
  const subtitle = teamGroupSubtitle || 'Individual Training';

  return (
    <Box
      sx={{
        backgroundColor: palette.background.paper,
        flexShrink: 0,
        px: 2.5,
        pt: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          mx: -2.5,
          mt: -2,
          mb: 1.5,
          px: 2.5,
          py: 0.75,
          backgroundColor: palette.primary.light,
          borderBottom: `1px solid ${palette.primary.main}`,
        }}
      >
        <UserAvatar src={memberPreview.profileImage} name={memberPreview.name} size={28} fontSize="0.75rem" />
        <PersonOutlineIcon sx={{ fontSize: 16, color: palette.primary.dark }} />
        <Typography variant="caption" sx={{ color: palette.primary.dark, fontWeight: 600, flex: 1 }}>
          Viewing training for{' '}
          <Typography component="span" variant="caption" fontWeight={800} sx={{ color: palette.primary.dark }}>
            {memberPreview.name}
          </Typography>
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1.5 }}>
        <Box>
          <Typography variant="subtitle2" fontWeight={700} lineHeight={1.2} color="text.primary">
            {subtitle}
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose} aria-label="Close" className="coach-athlete-modal-close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Divider />
    </Box>
  );
};

export default CoachAthleteModalHeader;
